import {
  Component,
  Input,
  OnChanges,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { ERROR_OBJECTS, ErrorMessageService } from '@app/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-form-error-wrapper',
  templateUrl: './form-error-wrapper.component.html'
})
export class FormErrorWrapperComponent
  implements OnInit, OnChanges, AfterViewInit {
  @Input()
  public control: any;
  @Input()
  public controlName: string;
  @Input()
  public apiErrorType?: string;
  //TODO: How to pass apiServiceUrl
  @Input()
  public apiServiceUrl?: string;

  // TODO : Setup config object
  @Input()
  public config?: ErrorModel.Config;

  @Input()
  public showError = false;

  public errorObject: Object = ERROR_OBJECTS;
  public errorKeys: string[];
  public apiErrorMessage: string;

  constructor(
    private errorMessageService: ErrorMessageService,
    private toastrService: ToastrService
  ) {
    errorMessageService.errors$.subscribe(
      (errors: ErrorModel.ErrorMessageObject[]) => {
        errors
          .filter(
            e => e.type === this.apiErrorType
            //  && e.serviceUrl == this.apiServiceUrl
          )
          .map(e => {
            if (e.type === 'Birthdate_Error') {
              this.toastrService.warning(e.error);
            } else {
              this.apiErrorMessage = e.error;
            }
          });
      }
    );
  }

  ngOnInit() {}

  ngOnChanges() {
    this.errorKeys = Object.keys(this.errorObject);
  }

  ngAfterViewInit() {
    this.control.valueChanges.subscribe(() => {
      this.apiErrorMessage = '';
    });
  }

  formateError(errorMessage: string, errorObj: any): string {
    const types = ['min', 'max', 'requiredLength'];

    types.forEach(type => {
      if (!!errorObj[type]) {
        errorMessage = errorMessage.replace(/{{value}}/g, errorObj[type]);
      }
    });
    return errorMessage.replace(/{{field}}/g, this.controlName);
  }

  hasError() {
    return (
      (this.control.errors && this.control.touched) || this.apiErrorMessage
    );
  }
  hasPlaceHoderError() {
    return (
      this.config &&
      this.config.placeholderOnly &&
      (this.control.errors && this.control.touched)
    );
  }
}
